export var MaskType;
(function (MaskType) {
    MaskType[MaskType["phoneNumber"] = 0] = "phoneNumber";
    MaskType[MaskType["date"] = 1] = "date";
    MaskType[MaskType["currency"] = 2] = "currency";
})(MaskType || (MaskType = {}));
